import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wpd-ivr-dashboard',
  templateUrl: './wpd-ivr-dashboard.component.html',
  styleUrls: ['./wpd-ivr-dashboard.component.scss']
})
export class WpdIvrDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
